import React from 'react';
import PropTypes from 'prop-types';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, DotGroup } from 'pure-react-carousel';
import styled from 'styled-components';
import Color from 'color';
import { Image } from './Image';
import { HTMLContent } from './Content';
import { breakpoints, theme, media, color } from '../theme';
import { vr } from '../utils';
import arrow from '../img/arrow.svg';

export function Carousel({ baneguide, isPreviewMode }) {

  return (
    <C
      naturalSlideWidth={100}
      naturalSlideHeight={60}
      totalSlides={baneguide.length}
    >
      <ButtonBack><Image src={arrow} /></ButtonBack>
      <ButtonNext><Image src={arrow} /></ButtonNext>
      <Slider data-isPreviewMode={isPreviewMode}>
        {baneguide && baneguide.map((bane, index) => (
          <Slide index={index} key={`bane-${index}`}>
            <Image src={bane.image} />
            <div className="content">
              <h2>Hul {index + 1}</h2>
              <div className="data">
                <small>Par <strong>{bane.par}</strong></small>
                <small>Hcp <strong>{bane.hcp}</strong></small>
              </div>
              <HTMLContent>{bane.desc}</HTMLContent>
            </div>
          </Slide>
        ))}
      </Slider>
      <DotGroup dotNumbers />
    </C>
  );
}

const C = styled(CarouselProvider)`
  background: #fff;
  position: relative;
  box-shadow: 0 20px 30px ${Color(color.brown).alpha(0.1)};
  margin: ${vr(1)} auto;
  max-width: initial !important;

  > div {
    width: 100%;
  }

  @media (max-width: ${breakpoints.tabletS - 1}px) {
    margin-left: -${theme.containerPadding};
    margin-right: -${theme.containerPadding};
    
    li {
      padding-bottom: 0 !important;
      height: 1100px !important;
    }
  }

  .gatsby-image-wrapper img {
    outline: 0;
    border: 0;
  }

  /* [data-isPreviewMode="true"] li {
    height: 1100px !important;

    img {
      width: 50% !important;
      margin: 0 auto !important;
    }
  } */

  li {

    > div {
      position: absolute;
      width: auto;
      height: auto;
      top: ${theme.containerPadding};
      right: ${theme.containerPadding};
      bottom: ${theme.containerPadding};
      left: ${theme.containerPadding};
      overflow: hidden;

      .data {
        margin-top: ${vr(0.25)};
        margin-bottom: ${vr(0.5)};
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        & + *, & + * > *:first-child {
          margin-top: 0;
        }
      }

      h2 {
        margin-top: 0;
      }

      .gatsby-image-wrapper {
        z-index: 10;
        height: auto;
        width: 90%;
        margin: 0 auto;
        max-width: 320px;

        img {
          outline: 0;
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 20;
      }

      small {
        margin-right: 1rem;
      }

      h3, h4 {
        margin-top: 0;
        font-size: 1rem;
      }

      @media ${media.tabletS} {
        top: 2rem;
        right: 4rem;
        bottom: 2rem;
        left: 4rem;

        .content {
          width: 50%;  
          padding: 1rem 0;
        }

        .gatsby-image-wrapper {
          width: 30% !important;
          padding-bottom: 0 !important;
        }

        .gatsby-image-wrapper, > img {
          width: 100%;
          height: 100%;
          position: absolute !important;
          left: auto;
          right: 0;
          top: 0;
          max-width: initial;

          img, picture {
            height: 100% !important;
            object-fit: contain !important;
            object-position: right center !important;
          }
        }

        > img {
          width: auto;
        }
      }
    }
  }

  .carousel__back-button,
  .carousel__next-button {
    position: absolute;
    top: 50%;
    height: 3rem;
    width: 3rem;
    background: #fff;
    box-shadow: 0 3px 8px ${Color(color.gold).alpha(0.1)};
    border-radius: 50%;
    appearance: none;
    border: 1.5px solid #fff;
    display: none;
    justify-content: center;
    align-content: center;
    outline: 0;
    z-index: 100;
    transition: ${theme.transitionShortAndFunction};
    transition-property: opacity, border-color;
    user-select: none;

    @media ${media.tabletS} {
      display: flex;
    }

    &[disabled] {
      opacity: 0;
      cursor: auto;
    }

    &:focus {
      border-color: ${color.gold};
    }

    &:active {
      img {
        margin-top: 2px;
      }
    }

    .gatsby-image-wrapper {
      min-width: auto;
      margin: 0;
    }

    img {
      pointer-events: none;
      position: absolute !important;
      display: block;
      top: 50% !important;
      width: 100% !important;
      height: auto !important;
    }
  }

  .carousel__back-button {
    left: 0;
    transform: translate(-49%, -50%);
    
    img {
      transform: translateY(-50%) rotate(90deg) scale(0.6)
    }
  }
  
  .carousel__next-button {
    right: 0;
    transform: translate(49%, -50%);

    img {
      transform: translateY(-50%) rotate(-90deg) scale(0.6);
    }
  }

  .carousel__dot-group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: ${vr(0.5)} 0;
    flex-wrap: wrap;
    margin: 0 ${theme.containerPadding};

    @media ${media.landscapeS} {
      margin: 0;
    }

    button {
      appearance: none;
      background: transparent;
      border: 0;
      font-size: .8rem;
      color: ${color.gold};
      padding: 5px 10px;
      display: inline-block;
      position: relative;
      width: 11%;
      width: calc(1/9);

      @media ${media.landscapeS} {
        width: auto;
      }

      span {
        color: inherit;
      }
      
      &:hover {
        color: ${color.brown};
        background: ${Color(color.gold).alpha(0.1)};
      }
      
      &.carousel__dot--selected {
        color: ${color.offwhite};
        background: ${color.gold};
      }
    }
  }
`;

Carousel.propTypes = {
  baneguide: PropTypes.arrayOf(
    PropTypes.shape({
      desc: PropTypes.string,
      par: PropTypes.number,
      hcp: PropTypes.number,
      image: PropTypes.oneOfType([ PropTypes.object, PropTypes.string ]),
    }),
  ).isRequired,
};
